import React from 'react';

//  local components
import ResultPagination from './resultPagination'
import SupportMaterialListing from './supportMaterialListing'

function ResultsContainer(props) {

    return (
        <>
            {props.results && props.results.length > 0 &&
                <ResultPagination 
                    searchPage={props.searchPage} 
                    firstPage={props.firstPage} 
                    lastPage={props.lastPage} 
                    handlePageClick={props.handlePageClick}
                    handlePrevPageClick={props.handlePrevPageClick}
                    handleNextPageClick={props.handleNextPageClick} 
                />
            }
            
            <div id="alumni-list">
            
                { props.results && props.results.length > 0 ?
                    <>
                    {props.results.map(result => (
                        <SupportMaterialListing 
                            key={result.id}
                            result={result}
                            handleRecommendedSearchClick={props.handleRecommendedSearchClick}
                            defaultRestrictedContentMessage={props.defaultRestrictedContentMessage}
                        />
                    ))}
                    </>
                :
                    <>
                    {!props.loading &&
                        <div className="tc-no-results">
                            No support materials found that match search criteria. <a onClick={props.handleResetFiltersClick} className="connections-link">Click here to reset your search criteria and try again.</a>
                        </div>
                    }
                    </>
                }

            </div>

            <br />
            {props.results && props.results.length > 0 &&
                <ResultPagination 
                    searchPage={props.searchPage} 
                    firstPage={props.firstPage} 
                    lastPage={props.lastPage} 
                    handlePageClick={props.handlePageClick}
                    handlePrevPageClick={props.handlePrevPageClick}
                    handleNextPageClick={props.handleNextPageClick} 
                />
            }
        </>
    );
}

export default ResultsContainer;